import { ClipboardCheck, HeartPulse, ShieldCheck, Timer } from 'lucide-react';
import { EHS_STATS } from './mockIncidentData';

const WIDGETS = [
  {
    id: 'lti',
    label: 'Days Since Last LTI',
    value: EHS_STATS.daysSinceLastLti,
    suffix: 'days',
    sublabel: `Last LTI: ${EHS_STATS.lastLtiDate}`,
    icon: Timer,
    accent: 'emerald',
    ring: 'border-emerald-200 bg-emerald-50',
    valueClass: 'text-emerald-700',
    iconClass: 'text-emerald-700 bg-emerald-50 ring-emerald-500/25',
  },
  {
    id: 'audits',
    label: 'Safety Audits Passed',
    value: EHS_STATS.safetyAuditsPassed,
    suffix: 'active',
    sublabel: 'YTD · ISO 45001 aligned',
    icon: ShieldCheck,
    accent: 'cyan',
    ring: 'border-logi-accent/25 bg-logi-accent/10',
    valueClass: 'text-logi-accent',
    iconClass: 'text-logi-accent bg-logi-accent/10 ring-logi-accent/30',
  },
  {
    id: 'renewals',
    label: 'Pending Renewals',
    value: EHS_STATS.pendingMedicalRenewals + EHS_STATS.pendingHazmatRenewals,
    suffix: 'drivers',
    sublabel: `${EHS_STATS.pendingMedicalRenewals} medical · ${EHS_STATS.pendingHazmatRenewals} HAZMAT`,
    icon: HeartPulse,
    accent: 'amber',
    ring: 'border-amber-200 bg-amber-50',
    valueClass: 'text-amber-700',
    iconClass: 'text-amber-700 bg-amber-50 ring-amber-500/25',
  },
];

export default function EhsComplianceWidget() {
  return (
    <section
      aria-label="EHS compliance statistics"
      className="overflow-hidden rounded-xl border border-logi-grid bg-white backdrop-blur-sm"
    >
      <div className="flex items-center gap-2 border-b border-logi-grid px-4 py-3">
        <ClipboardCheck className="h-4 w-4 text-emerald-700" strokeWidth={1.75} />
        <div>
          <h3 className="text-sm font-bold text-logi-text">EHS Compliance Widget</h3>
          <p className="text-[11px] text-logi-text0">Environment, Health &amp; Safety · Live counters</p>
        </div>
      </div>

      <div className="grid grid-cols-1 gap-3 p-4 sm:grid-cols-3">
        {WIDGETS.map((widget) => {
          const Icon = widget.icon;
          return (
            <article
              key={widget.id}
              className={`rounded-xl border p-4 ${widget.ring}`}
            >
              <div className="flex items-start justify-between gap-2">
                <div
                  className={`flex h-9 w-9 items-center justify-center rounded-lg ring-1 ${widget.iconClass}`}
                >
                  <Icon className="h-4 w-4" strokeWidth={1.75} />
                </div>
              </div>
              <p className="mt-3 text-[10px] font-semibold uppercase tracking-wider text-logi-text0">
                {widget.label}
              </p>
              <p className="mt-1 flex items-baseline gap-1.5">
                <span className={`font-mono text-3xl font-bold tabular-nums ${widget.valueClass}`}>
                  {widget.value}
                </span>
                <span className="text-xs text-logi-text0">{widget.suffix}</span>
              </p>
              <p className="mt-1 text-[10px] text-logi-text0">{widget.sublabel}</p>
            </article>
          );
        })}
      </div>
    </section>
  );
}
